import { render } from "./TOSModal.vue?vue&type=template&id=9ff37c1a&scoped=true"
import script from "./TOSModal.vue?vue&type=script&lang=js"
export * from "./TOSModal.vue?vue&type=script&lang=js"

import "./TOSModal.vue?vue&type=style&index=0&id=9ff37c1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ff37c1a"]])

export default __exports__